import _defineProperty from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["render", "roles"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { hasTokenExpired, hasPermission } from '../utils';
import LoginRedirect from './LoginRedirect';

function PrivateRoute(_ref) {
  var _render = _ref.render,
      roles = _ref.roles,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useAuth = useAuth(),
      user = _useAuth.user;

  return React.createElement(Route, _objectSpread(_objectSpread({}, rest), {}, {
    render: function render(props) {
      if (hasTokenExpired()) return React.createElement(LoginRedirect, null);
      if (user.staff || hasPermission(user, roles)) return _render(props);
      return React.createElement(Redirect, {
        to: {
          pathname: '/',
          state: {
            from: props.location
          }
        }
      });
    }
  }));
}

export default PrivateRoute;